import { useCallback, useContext } from "react"

import { getOptionValues } from 'app/components/commonFilters/hooks'
import { CommonFiltersAlertsContext } from '../context'


export default function useCommonFiltersAlerts() {
    const { state, setState } = useContext(CommonFiltersAlertsContext)

	const updateState = useCallback(newState => {
        setState(state => ({ ...state, ...newState}))
	}, [setState])

    const setAlerts = useCallback((data, isLoading=true) => {
        updateState({ alerts: data, alertType: null, alertSubtype: null, ikeys: [], isLoadingAlerts: isLoading })
    }, [updateState])

    const setAlertName = useCallback(op => {
        updateState({ maxRangeDate: op?.daysRange })
        updateState({ alertName: getOptionValues(op) })
    }, [updateState])

    const setAlertType = useCallback(op => {
        updateState({ alertType: getOptionValues(op) })
    }, [updateState])

    const setAlertSubtype = useCallback(op => {
        updateState({ alertSubtype: getOptionValues(op) })
    }, [updateState])

    const setComparison = useCallback(op => {
        updateState({ comparison: getOptionValues(op) })
    }, [updateState])

    const setIkeys = useCallback(op => {
        updateState({ ikey: getOptionValues(op) })
    }, [updateState])

    const setAlertsOccupancy = useCallback(op => {
        updateState({ alertsOccupancy: getOptionValues(op) })
    }, [updateState])

	return {
		alerts: state.alerts, alertName: state.alertName, alertType: state.alertType, alertSubtype: state.alertSubtype,
        comparison: state.comparison, ikey: state.ikey, isLoadingAlerts: state.isLoadingAlerts,
        maxRangeDate: state.maxRangeDate, alertsOccupancy: state.alertsOccupancy,

		updateState, setAlerts, setAlertType, setAlertSubtype, setComparison, setIkeys, setAlertName,
        setAlertsOccupancy
	}
}